
const handleResponse = {
  apiResponse(res) {
    let type,msg;
    try {
      if (res && ( JSON.stringify(res).toUpperCase().includes('FAIL') || JSON.stringify(res).toUpperCase().includes('ValidationError') )) {
        type = 'error'
      } else {
        type = 'success'
      }
    } catch (e) {
      type = 'error'
      res = e
    }
    //console.log(res);
    if (res && res.data && res.data.message) msg = JSON.stringify(res.data.message);
    else if (res !== '') msg = JSON.stringify(res);
    else msg=type;
    //console.log(msg);
    //let msg = JSON.stringify(res)
    return {type, msg}
  }
}

export default handleResponse;
